export const HOST = 'localhost';
export const PORT = '8080';
export const ADDR = `${HOST}:${PORT}`;
export const SCHEME = 'http';
export const PREFIX = `${SCHEME}://${ADDR}`;